import React from 'react'
import {
  List as ListIcon,
  // Map,
  Activity
} from 'react-feather'
import { useHistory } from 'react-router-dom'
import { TabItem } from '../../../components'
// import auth from '../../../utils/auth'

const ListNav = ({fromOrganization, embed, activeTab, onChange}) => {
  const history = useHistory()
  // const { isOfficial, isVerified, isUser } = auth()
  const mobilePadding = embed ? 'pt-2 px-3 pb-2' : 'pt-5 px-5 pb-3'

  const handleStatisticLink = () => {
    if (fromOrganization) {
      // history.push('/program-statistic-organization')
      onChange('Statistic View')
    } else {
      history.push('/program-statistic')
    }
  }

  return (
    <div className="flex border-b mb-5 lg:mb-8">
      <TabItem
        selected={activeTab}
        onClick={onChange}
        text="List View"
        icon={<ListIcon style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
      <TabItem
        selected={activeTab}
        onClick={handleStatisticLink}
        text="Statistic View"
        icon={<Activity style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      />
      {/* <TabItem
        selected={activeTab}
        onClick={() => {
          if (isOfficial || isVerified || isUser) {
            history.push('/program-map')
          } else {
            history.push('/login')
          }
        }}
        text="Map View"
        icon={<Map style={{width: '20px'}}/>}
        className={`${mobilePadding} lg:pt-0 lg:px-0 lg:pb-4 lg:pr-1 lg:ml-12`}
        accent={embed ? false : true}
        uppercase={embed ? false : true}
        embed
      /> */}
    </div>
  )
}

export { ListNav }
